module.exports = __webpack_public_path__ + "static/intro.tw-82ca06be178c3cb76352043240f4150a.svg";